import React, { useContext } from 'react';
import Heading from './components/Heading/Heading';
import ApkList from './components/ApkList/ApkList';
import RestaurantsControlPanel from './components/RestaurantsControlPanel/RestaurantsControlPanel';
import SearchFields from './components/SearchFields/SearchFields';
import Breadcrumbs from './components/Breadcrumbs/Breadcrumbs';
import Customers from './components/Customers/Customers';
import Restaurants from './components/Restaurants/Restaurants';
import BottomControlPanel from './components/BottomControlPanel/BottomControlPanel';
import CancelAndSaveButtons from './components/CancelAndSaveButtons/CancelAndSaveButtons';
import {
	ApkAssignmentContext,
	IApkAssignmentContext,
} from 'modules/FirmwareAndApp/Apk/ApkAssignment/apkAssignmentState/apkAssignmentContext';
import classNames from 'classnames';
import style from './RestaurantsSection.module.scss';

const RestaurantsSection: React.FC = () => {
	const { activeItemToDisplay, allCustomers, restaurants, apk } =
		useContext<IApkAssignmentContext>(ApkAssignmentContext);

	const sectionCustomersClasses = classNames(style.sectionWrapper, {
		[style.hide]: activeItemToDisplay !== 'customers',
	});
	const sectionSubcategoriesClasses = classNames(style.sectionWrapper, {
		[style.hide]: activeItemToDisplay !== 'restaurants',
	});
	const sectionDishesClasses = classNames(style.sectionWrapper, style.marginTopZero, {
		[style.hide]: activeItemToDisplay !== 'apk',
	});

	return (
		<div className={style.container} data-test="RestaurantsSection">
			<div className={style.wrapper}>
				<div>
					<Heading />
					<RestaurantsControlPanel />
					<SearchFields />
					<Breadcrumbs />
					<div className={style.sections}>
						<div className={sectionCustomersClasses}>{allCustomers.length ? <Customers /> : null}</div>
						<div className={sectionSubcategoriesClasses}>{restaurants.length ? <Restaurants /> : null}</div>
						<div className={sectionDishesClasses}>{apk.length ? <ApkList /> : null}</div>
					</div>
				</div>
				<BottomControlPanel />
			</div>
			<CancelAndSaveButtons />
		</div>
	);
};

export default RestaurantsSection;
